import tripStatusesCodes from './../trip-statuses';
import {tripStates} from './../trip-routes';
import {STAGE, STAGE_LABELS} from './../services/trip-details-service';
export default function TripListController(
    $scope,
    $state,
    tripListService,
    tripAPI,
    tripStatuses,
    deviceDetector,
    l10nService,
    userService,
    MOMENT,
    flightsUtils,
    tripItemRailRecommendationService
) {
    'ngInject';
    const vm = this;

    let offset = 1;
    const limit = 20;
    const TRIP_LIST_PREFIX = 'Trip: ';
    const TRIP_ID_DEFAULT_LENGTH = 6;


    Object.assign(vm, {
        $onInit,
        convertTravelDate,
        getStatus,
        openTripDetails,
        getTripList,
    });

    function $onInit() {
        getTripList();
        initWatchers();
    }

    function openTripDetails(tripId, departmentId) {
        $state.go(tripStates.TRIP_DETAILS, {id: tripId, department: departmentId});
    }

    function getTripList() {
        offset = 1;
        const {filters, sortField, sortOrder} = $scope;

        if (!filters.IncludePastTrips
            && !!filters.Status
            && filters.Status.text === tripStatusesCodes.PAST) {
            filters.IncludePastTrips = true;
            return;
        }
        tripListService.getList(filters, offset, limit, sortField, sortOrder)
            .then((trips) => $scope.trips = trips);
    }

    function getStatus({ApprovalStatus, Status, RelevantRuleLabels}) {
        if (Status === tripStatusesCodes.CONFIRMED && ApprovalStatus === STAGE.APPROVED) {
            return '';
        }

        if (angular.isDefined(RelevantRuleLabels) && angular.isDefined(STAGE_LABELS[ApprovalStatus])) {
            let labels = ' ';
            _.each(RelevantRuleLabels, (label, key) => {
               labels += key > 0 ? ' / ' + l10nService.localize(label) : l10nService.localize(label);
            });
            return l10nService.localize(STAGE_LABELS[ApprovalStatus]) + ' ' + labels;
        }

        if (angular.isDefined(STAGE_LABELS[ApprovalStatus])) {
            return STAGE_LABELS[ApprovalStatus];
        }

        return l10nService.localize(ApprovalStatus);
    }

    function initWatchers() {
        $scope.$watchGroup(['sortField', 'sortOrder'], (newVal, oldVal) => {
            if (noChanges(newVal, oldVal)) {
                return;
            }
            getTripList();
        });

        $scope.$watch('filters', (newVal, oldVal) => {
            if (newVal === oldVal) {
                return;
            }
            getTripList();
        }, true);

        function noChanges(newArray, oldArray) {
            return newArray.toString() === oldArray.toString();
        }
    }

    function convertTravelDate(date) {
        const {dateFormat} = userService.getRegionalSettings();
        return date ? MOMENT.format(date, dateFormat) : '';
    }

    $scope.isMobile = deviceDetector.isMobile();
    $scope.mobileIsSearchTabActive = true;

    $scope.trips = [];
    $scope.tripStatuses = tripStatuses;

    $scope.filters = {
        Status: angular.copy(tripStatuses[0]),
        IncludePastTrips: false,
    };

    $scope.sortField = 'TripId';
    $scope.sortOrder = 'Desc';

    $scope.optionsDateFrom = {
        placeholder: l10nService.localize('From'),
        months: 2,
        start: moment(),
        dependentPikers: ['optionsDateTo'],
    };
    $scope.optionsDateTo = {
        placeholder: l10nService.localize('To'),
        months: 2,
        start: moment(),
    };

    $scope.showCurrentStage = showCurrentStage;

    $scope.$watch('filters.DateFrom', () => {
        const {dateFormat} = userService.getRegionalSettings();
        const dateFrom = moment($scope.filters.DateFrom, dateFormat);
        const dateTo = moment($scope.filters.DateTo, dateFormat);

        if (dateFrom.isAfter(dateTo)) {
            $scope.filters.DateTo = null;
        }
    });

    $scope.loadMore = function() {
        offset += 1;
        tripListService.getList($scope.filters, offset, limit, $scope.sortField, $scope.sortOrder)
            .then(function(trips) {
                Array.prototype.splice.apply($scope.trips, [$scope.trips.length, 0].concat(trips));
            });
    };

    Object.defineProperty(
        $scope, 'isLoadMoreVisible', {
            get: function() {
                return $scope.trips.length === limit * offset;
            },
            set: function() {
            },
        }
    );

    $scope.updateFilters = function(remainKey, includePastTrips) {
        if (includePastTrips) {
            $scope.filters.IncludePastTrips = true;
        }

        $scope.filters.TripId = $scope.filters.TripId.replace(TRIP_LIST_PREFIX, '');

        _.chain(['TripId', 'Traveller', 'Location'])
            .difference([remainKey])
            .forEach(function(key) {
                $scope.tripsListForm[key].$setViewValue(undefined);
                $scope.tripsListForm[key].$render();
            })
            .value();
    };

    $scope.clearSearchForm = function() {
        $scope.filters.Location = '';

        const keys = ['TripId', 'Traveller', 'Location'];
        keys.forEach((key) => {
            $scope.tripsListForm[key].$setViewValue('');
            $scope.tripsListForm[key].$render();
        });
    };

    $scope.cleanSiblings = function() {
        if ($scope.focusedField) {
            $scope.updateFilters($scope.focusedField);
        }
    };

    $scope.findIds = function(pattern) {
        return tripAPI.findIds(pattern)
            .then((data) => {
                if (pattern.length > TRIP_ID_DEFAULT_LENGTH) {
                    return data.map((item) => TRIP_LIST_PREFIX + item);
                }

                return data;
            });
    };

    $scope.findTravellers = tripAPI.findTravellers;
    $scope.findLocations = tripAPI.findLocations;

    $scope.sort = function(field) {
        if ($scope.sortField === field) {
            if ($scope.sortOrder === '') {
                $scope.sortOrder = 'Desc';
            } else {
                $scope.sortOrder = '';
            }
        } else if (field === 'TripId') {
            $scope.sortField = field;
            $scope.sortOrder = 'Desc';
        } else {
            $scope.sortField = field;
            $scope.sortOrder = '';
        }
    };

    $scope.getFlightItinerary = function(date, flightList) {
        let flight;
        flightList.forEach((element) => {
            flight = element.FlightGroups[0].Flights[0].DepartureDate === date ? element : flight;
        });
        return flight;
    };

    $scope.getRailItinerary = function(date, railList) {
        let rail;
        railList.forEach((element) => {
            rail = element.Rails[0].DepartureDate === date ? element : rail;
        });
        return rail;
    };

    $scope.getFlightCities = function(date, flightList) {
        let flight;
        flightList.forEach((element) => {
            flight = element.FlightGroups[0].Flights[0].DepartureDate === date ? element : flight;
        });
        return flightsUtils.collectAllCities(flight.FlightGroups);
    };

    $scope.getRailCities = function(date, railList) {
        let rail;
        railList.forEach((element) => {
            rail = element.Rails[0].DepartureDate === date ? element : rail;
        });
        return tripItemRailRecommendationService.getAllStations(rail);
    };

    function showCurrentStage(trip) {
        return trip.ApprovalStatus !== 'NotSent'
            && trip.ApprovalStatus !== 'RemovedAfterToleranceFail';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/list/tripListController.js